import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;


export const store = (data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/settings`,
    needToken: true,
    data:data
  });
};
export const getList = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/accountingSoftware`,
    needToken: true
  });
};
export const sharedContacts = () => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/sharedContacts?paginate=false`,
    needToken: true
  });
};
export const setUserState = (userId, action) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "put",
    url: `${baseUrl}/projects/${projectId}/users/${userId}/states`,
    needToken: true,
    data: action
  });
};